/* eslint-disable mastery/known-imports */
// eslint-disable-next-line no-restricted-imports
import { ToastOptions as TOpts } from 'react-toastify';
import { systemBannerComponent } from './SystemBannerComponent';

export const systemBanner = systemBannerComponent;
export type SystemBannerOpts = TOpts;
